export const COLLAPSED_WIDGET_HEIGHT = 57;

export const WIDGET_MESSAGE = {
  OPEN: 'open',
  CLOSE: 'close',
  RESIZE: 'resize',

  HANDSHAKE_REQUEST: 'handshake_request',
  HANDSHAKE_RESPONSE: 'handshake_response',

  BOOKING_COMPLETED: 'booking_completed',
  BOOKING_CANCELED: 'booking_canceled',

  DESTROY: 'destroy',
  UPDATE: 'update',
} as const;

export const ORIGIN_TRUST_STATUS = {
  PENDING: 'pending',
  TRUSTED: 'trusted',
  UNTRUSTED: 'untrusted',
} as const;
